import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../services/api';
import { isAuthenticated } from '../services/auth';
import { useTenantFromUrl } from '../hooks/useTenantFromUrl';

/**
 * Gates children to users with global super-admin (DEVELOPER / is_super_admin on whoami).
 * Redirects others to tenant Settings root (still inside the same tenant URL).
 */
function RequireSuperAdmin({ children }) {
  const { tenantPath } = useTenantFromUrl();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (!isAuthenticated()) {
      setStatus('denied');
      return;
    }
    api
      .get('/whoami')
      .then((res) => setStatus(res.data?.is_super_admin === true ? 'ok' : 'denied'))
      .catch(() => setStatus('denied'));
  }, []);

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  if (status === 'loading') {
    return <div className="loading" style={{ padding: '2rem', textAlign: 'center' }}>Loading…</div>;
  }
  if (status === 'denied') {
    return <Navigate to={tenantPath('/settings')} replace />;
  }
  return children;
}

export default RequireSuperAdmin;
